import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_616_1228)">
      <path
        d="M3.6058 9.0087C3.4087 9.15942 3.21159 9.37971 3.15362 9.66957C3.07246 10.0522 3.14203 10.5391 3.50145 10.9217C3.95362 11.3739 4.63768 11.5014 4.93913 11.5246C5.73913 11.5826 6.5971 11.1768 7.24638 10.7362C7.50145 10.5623 7.93043 10.2029 8.34783 9.64638C7.42029 9.17101 6.26087 8.63768 5.03188 8.68406C4.38261 8.70725 3.93043 8.83478 3.6058 9.0087ZM15.3623 11.1304C15.7681 10.1681 16 9.11304 16 8C16 3.5942 12.4058 0 8 0C3.5942 0 0 3.5942 0 8C0 12.4058 3.5942 16 8 16C10.6667 16 13.0203 14.6899 14.4812 12.6841C13.1014 12.0116 10.8406 10.8754 9.43768 10.2029C8.77681 10.9681 7.7913 11.7217 6.67826 12.0464C5.98261 12.2551 5.34493 12.3362 4.69565 12.1971C4.03478 12.058 3.55942 11.7565 3.28116 11.4551C3.14203 11.2928 2.97971 11.1072 2.85217 10.8638C2.86377 10.8754 2.86377 10.8986 2.86377 10.9101C2.86377 10.9101 2.7942 10.7942 2.74783 10.6087C2.72464 10.5159 2.70145 10.4232 2.68986 10.3304C2.67826 10.2609 2.67826 10.1913 2.68986 10.1333C2.67826 10.0174 2.68986 9.88985 2.71304 9.76232C2.78261 9.43768 2.91014 9.07826 3.26957 8.74203C4.03478 7.98841 5.06667 7.95362 5.6 7.95362C6.38841 7.96522 7.75652 8.30145 8.91594 8.71884C9.24058 8.03478 9.44928 7.31594 9.57681 6.81739H4.76522V6.29565H7.23478V5.25217H4.25507V4.71884H7.23478V3.67536C7.23478 3.53623 7.26957 3.42029 7.48986 3.42029H8.66087V4.71884H11.8957V5.24058H8.66087V6.28406H11.2464C11.2464 6.28406 10.9797 7.73333 10.1797 9.15942C11.9768 9.7971 14.5159 10.7942 15.3623 11.1304Z"
        fill="#009FE2"
      />
    </g>
    <defs>
      <clipPath id="clip0_616_1228">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
